export default "__VITE_ASSET__73bd6066__"